import styled from 'styled-components';
import {UsefulLinksItemDefaultBox} from './useful-links-item.default.box';

export const UsefulLinksItemCasino777Box = styled(UsefulLinksItemDefaultBox)`
    color: ${props => props.active ? props.theme.colors.textContrast : props.theme.colors.text};

    &:hover {
        color: ${props => props.theme.colors.textContrast};
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        ${({theme}) => theme.font.presets.body}
    }
`;